module.exports = __webpack_public_path__ + "img/202504_04.abcc9989.jpg";